export default "assets/images/ecofriendly-f362e21d.svg";